import { ComplianceModule } from './compliance-landing/compliance.module';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Constant } from './modules/shared/constants';



const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./compliance-landing/compliance.module').then(m => m.ComplianceModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
